/** 成功加载远程服务器js的回调
 * src 文件地址
 * callback 加载成功的回调
 * **/
function loadScript(src, callback) {
  let script = document.createElement('script')
  let head = document.getElementsByTagName('head')[0];
  script.type = 'text/javascript';
  script.src = src;
  if (script.addEventListener) {
    script.addEventListener('load', function () {
      callback();
    }, false);
  } else if (script.attachEvent) {
    script.attachEvent('onreadystatechange', function () {
      let target = window.event.srcElement;
      if (target.readyState == 'loaded') {
        callback();
      }
    });
  }
  head.appendChild(script);
}
// 获取环境
function getEnv() {
  const host = window.location.host;
  return host.indexOf("test") > -1 || host.indexOf("local") > -1 || host.indexOf("127.0.0.1") > -1
    ? "test"
    : host.indexOf("uat") > -1
    ? "uat"
    : "www";
};
// 采招项目跳转
function toCzItem (){

  let host = getEnv();
  if (host == 'test') {
    window.location.href=`http://test-ebidding-mobile.onelinkplus.com`
  }else if(host == 'uat'){
    window.location.href=`http://uat-ebidding-mobile.onelinkplus.com`
  }else{
    window.location.href=`http://ebidding-mobile.onelinkplus.com`
  }
}
// 复星供应商库跳转
function toFosunSupplierUrl (){

  let host = getEnv();
  if (host == 'test') {
    window.location.href=`http://test-fosuppliers.onelinkplus.com/`
  }else if(host == 'uat'){
    window.location.href=`http://uat-fosuppliers.onelinkplus.com/`
  }else{
    window.location.href=`http://fosuppliers.onelinkplus.com/`
  }
}

const onelink_mdata_userinfo = "3rmmkjimasd43423k";
export {
  loadScript,
  toCzItem,
  toFosunSupplierUrl,
  getEnv,
  onelink_mdata_userinfo
}


// WEBPACK FOOTER //
// ./src/assets/js/utils.js